import { getContractExtensionV3, getOfferProductsV3 } from '@eneco/dc/services';
import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
} from '@monorepo-types/dc';
import { ApiError } from 'next/dist/server/api-utils';
import { fromPromise } from 'xstate';

import { getOfferRequestBody } from './getOffer.helpers';
import { FlowConsumerContextEnergy as FlowContext } from '../../../context';

type getOfferContext = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  values: FlowContext;
  allowDynamicOrHybridOnly?: boolean;
};

const getOffer = async ({ businessUnit, label, values, allowDynamicOrHybridOnly = false }: getOfferContext) => {
  const requestBody = getOfferRequestBody(values, allowDynamicOrHybridOnly);

  try {
    const response = await getOfferProductsV3({
      businessUnit: businessUnit,
      label: label,
      requestBody,
    });

    if (!response.data?.productCombinations?.length) {
      throw new Error('Not Found');
    }

    return response.data;
  } catch (error) {
    if (error instanceof ApiError) {
      if (error.statusCode === 500) {
        throw new Error('Internal error');
      }
      throw new Error('Not Found');
    }

    if (error instanceof Error) {
      throw new Error('Not Found');
    }
    throw new Error('Failed to fetch');
  }
};

const getContractExtension = async ({ businessUnit, label, values }: getOfferContext) => {
  try {
    const response = await getContractExtensionV3({
      businessUnit: businessUnit,
      label: label,
      accountId: Number(values.accountId),
      customerId: Number(values.customerId),
    });

    if (!response.data?.productCombinations?.length) {
      throw new Error('Not Found');
    }

    return response.data;
  } catch (error) {
    if (error instanceof ApiError) {
      if (error.statusCode === 500) {
        throw new Error('Internal error');
      }

      throw new Error('Not Found');
    }

    if (error instanceof Error) {
      throw new Error('Failed to fetch');
    }
    throw new Error('Failed to fetch');
  }
};

export type getOfferOutput = Awaited<ReturnType<typeof getOffer>>;
export type getContractExtensionOutput = Awaited<ReturnType<typeof getContractExtension>>;

export const actors = {
  getOffer: fromPromise<getOfferOutput, getOfferContext>(async ({ input }) => await getOffer(input)),
  getContractExtension: fromPromise<getContractExtensionOutput, getOfferContext>(
    async ({ input }) => await getContractExtension(input),
  ),
};
